import { hereMapsService } from '@/_services'
import * as types from './types'

const actions =  {
  setHereMapsMap ({ commit }, { map }) {
    commit(types.SET_HERE_MAPS_MAP, { map })
  },
  setHereMapsDefaultLayer ({ commit }, { defaultLayer }) {
    commit(types.SET_HERE_MAPS_DEFAULT_LAYER, { defaultLayer })
  },
  setHereMapsBehaviors ({ commit }, { mapBehaviors }) {
    commit(types.SET_HERE_MAPS_MAP_BEHAVIORS, { mapBehaviors })
  },
  setHereMapsPlatform ({ commit }, { platform }) {
    commit(types.SET_HERE_MAPS_PLATFORM, { platform })
  },
  calculateHereMapsRoute({ commit }, { locations, mode = 'fastest;car', representation = 'display', files }) {
    commit(types.SET_IS_MAP_INITIALIZING, { flag: true })
    hereMapsService.hereMapsDomIcons({ files })
    .then((markers) => {
      commit(types.SET_HERE_MAPS_MARKERS, { markers })
      let routingOptions = {
        mode,
        representation,
      }
      let routingMarkers = []
      locations.forEach(({ location, type }, index) => {
        routingOptions[`waypoint${index}`] = `${location.coordinates.lat},${location.coordinates.lng}`
        let icon = null
        switch (type) {
          case 'LocationPickup':
            const findPickup = markers.find(({ name }) => (name ===  type))
            if (findPickup != null) {
              icon = findPickup.domIcon
            }
            routingMarkers.push(hereMapsService.hereMapsMarker({ lat: location.coordinates.lat, lng: location.coordinates.lng, icon }))
            break;
          case 'LocationDelivery':
            const findDelivery = markers.find(({ name }) => (name ===  type))
            if (findDelivery != null) {
              icon = findDelivery.domIcon
            }
            routingMarkers.push(hereMapsService.hereMapsMarker({ lat: location.coordinates.lat, lng: location.coordinates.lng, icon }))
            break;
          case 'Depot':
            const findDepot = markers.find(({ name }) => (name ===  'LocationPickup'))
            if (findDepot != null) {
              icon = findDepot.domIcon
            }
            routingMarkers.push(hereMapsService.hereMapsMarker({ lat: location.coordinates.lat, lng: location.coordinates.lng, icon }))
            break;
          case 'LocationOriginAirPort':
            const findOriginAirPort = markers.find(({ name }) => (name ===  'LocationDelivery'))
            if (findOriginAirPort != null) {
              icon = findOriginAirPort.domIcon
            }
            routingMarkers.push(hereMapsService.hereMapsMarker({ lat: location.coordinates.lat, lng: location.coordinates.lng, icon }))
            break;
          case 'LocationOriginOceanPort':
            const findOriginOceanPort = markers.find(({ name }) => (name ===  'LocationDelivery'))
            if (findOriginOceanPort != null) {
              icon = findOriginOceanPort.domIcon
            }
            routingMarkers.push(hereMapsService.hereMapsMarker({ lat: location.coordinates.lat, lng: location.coordinates.lng, icon }))
            break;
          case 'LocationDestinationAirPort':
            const findDestinationAirPort = markers.find(({ name }) => (name ===  'LocationDelivery'))
            if (findDestinationAirPort != null) {
              icon = findDestinationAirPort.domIcon
            }
            routingMarkers.push(hereMapsService.hereMapsMarker({ lat: location.coordinates.lat, lng: location.coordinates.lng, icon }))
            break;
          case 'LocationDestinationOceanPort':
            const findDestinationOceanPort = markers.find(({ name }) => (name ===  'LocationDelivery'))
            if (findDestinationOceanPort != null) {
              icon = findDestinationOceanPort.domIcon
            }
            routingMarkers.push(hereMapsService.hereMapsMarker({ lat: location.coordinates.lat, lng: location.coordinates.lng, icon }))
              break;
          default:
            routingMarkers.push(hereMapsService.hereMapsMarker({ lat: location.coordinates.lat, lng: location.coordinates.lng, icon }))
            break;
        }
      })
      commit(types.SET_MAP_ROUTING_OPTIONS_MARKERS, { routingOptions, routingMarkers })
      commit(types.SET_IS_MAP_ROUTING, { flag: false })
    })
    .catch((error) => {
      console.error(error)
    })
    .finally(() => commit(types.SET_IS_MAP_INITIALIZING, { flag: false }))
  },
  setResetState({ commit }) {
    commit(types.SET_RESET_STATE)
  }
}

export default actions
